import { StandardColumnType } from '../Components/Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import {
  ColumnFaltkodType,
  BudgetTypes,
} from '../Components/EkonomiskAnalysEditColumnForm';
import { ekanalys_ekanalys_columns } from '../../../../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import { IColumn } from '../../../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';

export const findStandardColumnByFaltkod = (
  faltkod: ColumnFaltkodType | null,
  standardColumns: StandardColumnType[] | undefined
): StandardColumnType | undefined =>
  standardColumns != null
    ? standardColumns.find(standardColumn => standardColumn.FALTKOD === faltkod)
    : undefined;

export const showTimeInterval = (
  selectedStandardColumn: StandardColumnType | undefined
): boolean => {
  if (selectedStandardColumn == null) {
    return true;
  } else {
    return Boolean(selectedStandardColumn.DATUMINTERVALL);
  }
};

export const showTimeSettings = (intervalType: number | null): boolean =>
  intervalType === 0;

/** Finns det både "från och med tid" och "till och med tid" */
export const fromToTime = (
  selectedStandardColumn: StandardColumnType | undefined
): boolean => {
  if (selectedStandardColumn == null) {
    return true;
  } else {
    return (
      Boolean(selectedStandardColumn.TOMAR) &&
      Boolean(selectedStandardColumn.TOMPER)
    );
  }
};

export const showFromPeriod = (
  selectedStandardColumn: StandardColumnType | undefined
): boolean => {
  if (selectedStandardColumn == null) {
    return true;
  } else {
    return Boolean(selectedStandardColumn.FROMPER);
  }
};

export const showTomPeriod = (
  selectedStandardColumn: StandardColumnType | undefined
): boolean => {
  if (selectedStandardColumn == null) {
    return true;
  } else {
    return Boolean(selectedStandardColumn.TOMPER);
  }
};

export const showTomAr = (
  selectedStandardColumn: StandardColumnType | undefined
): boolean => {
  if (selectedStandardColumn == null) {
    return true;
  } else {
    return Boolean(selectedStandardColumn.TOMAR);
  }
};

export const showBudget = (
  selectedStandardColumn: StandardColumnType | undefined
): boolean => {
  if (
    selectedStandardColumn == null ||
    selectedStandardColumn.URVAL_BUDGET_TYP == null
  ) {
    return false;
  } else {
    return selectedStandardColumn.URVAL_BUDGET_TYP;
  }
};

export const showBudgetSuggestField = (
  budgetType: BudgetTypes | null
): boolean => {
  if (budgetType == null || budgetType === BudgetTypes.all) {
    return false;
  } else {
    return true;
  }
};

export const showUnit = (typValue: number | null): boolean => typValue === 3;

export const getStandardColumnSubTitle = (
  standardColumn: StandardColumnType | undefined,
  fromPeriodChecked: boolean,
  tomPeriodChecked: boolean
): string => {
  if (standardColumn == null) {
    return '';
  }
  if (standardColumn.DEFRUB2_1 && fromPeriodChecked === tomPeriodChecked) {
    return standardColumn.DEFRUB2_1;
  } else {
    return standardColumn.DEFRUB2 ? standardColumn.DEFRUB2 : '';
  }
};

export const getStandardColumnTitle = (
  standardColumn: StandardColumnType | undefined
): string => {
  if (standardColumn != null) {
    if (standardColumn.DEFRUB1) {
      return standardColumn.DEFRUB1;
    }
  }

  return '';
};

export const isBudgetColumn = (
  standardColumns: StandardColumnType[],
  column: ekanalys_ekanalys_columns
): boolean => {
  const standardColumn = findStandardColumnByFaltkod(
    column.FALTKOD as ColumnFaltkodType,
    standardColumns
  );

  return Boolean(standardColumn && standardColumn.URVAL_BUDGET_TYP);
};

export const getEmptyColumn = (): ekanalys_ekanalys_columns => ({
  LOPNR: null,
  ORDNINGS_NR: null,
  FALTKOD: null,
  INTERN: null,
  RESULTAT_TYP: null,
  FALT_TYP: -1,
  INTERVALL_TYP: -1,
  BAS: null,
  ANTAL_DECIMALER: null,
  VAND_TECKEN: null,
  BENAMNING: null,
  BENAMNING2: null,
  CODE_CAPTION: null,
  FROM_AR: null,
  FROM_AR_RELATIV: null,
  TOM_AR: null,
  TOM_AR_RELATIV: null,
  FROM_PER: null,
  FROM_PER_RELATIV: null,
  TOM_PER: null,
  TOM_PER_RELATIV: null,
  ENHET_ID: null,
  CategoryPath: null,
  Mallkolumn: null,
  MallValidCategories: null,
  RULLANDE: null,
  RULLANDE_PERIOD_TYP: null,
  RULLANDE_PERIOD_ANTAL: null,
  BUDGETTYP: null,
  BUDGETBENAMNING: null,
  HIDE_COLUMN: false,
  FORCE_CALCULATE: false,
  SPECIFIKATION: null,
  __typename: 'TEDAvenyEKAnalysColumn',
});

export const newModalColumn = (data: ekanalys_ekanalys_columns): IColumn => ({
  name: '',
  id: 0,
  data: data,
});

export const getNewColumn = (): ekanalys_ekanalys_columns => ({
  LOPNR: 5,
  ORDNINGS_NR: 0,
  FALTKOD: null,
  INTERN: false,
  RESULTAT_TYP: '\u0000',
  FALT_TYP: 0,
  INTERVALL_TYP: 0,
  BAS: '1',
  ANTAL_DECIMALER: 0,
  VAND_TECKEN: false,
  BENAMNING: '',
  BENAMNING2: '',
  CODE_CAPTION: 'Per bokf värde',
  FROM_AR: 0,
  FROM_AR_RELATIV: true,
  TOM_AR: 0,
  TOM_AR_RELATIV: true,
  FROM_PER: 0,
  FROM_PER_RELATIV: true,
  TOM_PER: 0,
  TOM_PER_RELATIV: true,
  ENHET_ID: 0,
  CategoryPath: null,
  Mallkolumn: null,
  MallValidCategories: null,
  RULLANDE: null,
  RULLANDE_PERIOD_TYP: null,
  RULLANDE_PERIOD_ANTAL: null,
  BUDGETTYP: '\u0000',
  BUDGETBENAMNING: null,
  HIDE_COLUMN: false,
  FORCE_CALCULATE: false,
  SPECIFIKATION: null,
  __typename: 'TEDAvenyEKAnalysColumn',
});
